<script setup lang="ts">
/**
 * For video, if we have the presigned url, we should just view that,
 * as that is the fastest way to get the file bytes. The file will be
 * downloaded in the background anyway. If the file is cached, then
 * we will never fetch the presigned url at all.
 *
 */

const props = defineProps({
  file: null,
  peek: { type: Boolean },
  showMatchedChunks: { type: Boolean }
})
const renderer = useTemplateRef("renderer")
const { width: containerWidth } = useElementSize(renderer)

const matchedChunks = computed(() => {
  if (!props.showMatchedChunks)
    return
  return props.file.matchedChunks()
})
</script>

<template>
  <div ref="renderer" class="renderer-container">
    <video-file-player
      :file
      :container-width
      :matched-chunks
      autoplay
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply h-full w-full flex items-center justify-center
  &.peek
    @apply w-[75vw] max-h-[75vh]
</style>
